import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const Goal = React.lazy(() => import("./goal/CreateGoal"));
const Project = React.lazy(() => import("./project/CreateProject"));
const Dashboard = React.lazy(() => import("./dashboard"));

export const PerformanceManagementConfigs = [
  {
    permittedRole: [
      // RoutePermittedRole.FRONTDESK,
      RoutePermittedRole.MANAGER,
      RoutePermittedRole.ADMIN,
      RoutePermittedRole.SUPER_ADMIN,
      RoutePermittedRole.MEMBER,
      // RoutePermittedRole.DOCTOR,
      // RoutePermittedRole.FINANCE_MANAGER,
      // RoutePermittedRole.HR_MANAGER,
    ],
    path: "/performance/dashboard",
    element: <Dashboard />,
  },
  {
    permittedRole: [
      // RoutePermittedRole.FRONTDESK,
      RoutePermittedRole.MANAGER,
      RoutePermittedRole.ADMIN,
      RoutePermittedRole.SUPER_ADMIN,
      RoutePermittedRole.MEMBER,
      // RoutePermittedRole.DOCTOR,
      // RoutePermittedRole.FINANCE_MANAGER,
      // RoutePermittedRole.HR_MANAGER,
    ],
    path: "/performance/goal",
    element: <Goal />,
  },

  {
    permittedRole: [
      // RoutePermittedRole.FRONTDESK,
      RoutePermittedRole.MANAGER,
      RoutePermittedRole.ADMIN,
      RoutePermittedRole.SUPER_ADMIN,
      RoutePermittedRole.MEMBER,
      // RoutePermittedRole.DOCTOR,
      // RoutePermittedRole.FINANCE_MANAGER,
      // RoutePermittedRole.HR_MANAGER,
    ],
    path: "/performance/project",
    element: <Project />,
  },
];
